module.exports = __webpack_public_path__ + "img/20200801_130547.4e2188be.jpg";